/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('EventRelationContactFactory', function($resource) {
	return $resource(
		'api/eventRelationContacts/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/**
 * Factory to search / retrieve an array of UserEventRelationContactListDto's
 */
angular.module('emsApp').factory('UserEventRelationContactListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/eventrelationcontact',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewEventRelationContactFactory', function($resource) {
	return $resource(
		'api/eventRelationContacts/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all EventRelationContacts without the use of paging
angular.module('emsApp').factory('NoPagingEventRelationContactFactory', function($resource) {
	return $resource(
		'api/eventRelationContacts/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible SalesStatuses Enum values without the use of paging
angular.module('emsApp').factory('NoPagingSalesStatusFactory', function($resource) {
	return $resource(
		'api/eventRelationContact/salesStatuses',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllEventRelationContactsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/eventRelationContacts/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});
